import {CreateVehicleFinancingTemplateRequestBody} from '@dms/api/sales';

import {FinancingTemplateDraft} from '../types/FinancingTemplateDraft';

type TemplateIdentity = Pick<
  FinancingTemplateDraft,
  'id' | 'archived' | 'automatic' | 'automaticPosition'
>;

/**
 * Turns the template body that was just saved into the editor draft shape the financing panel
 * rebases a vehicle configuration against, without waiting for a refetch. The write contract nests
 * the one-time costs while the read contract flattens them, so this is where that asymmetry is
 * resolved on the client.
 */
export function templateRequestBodyToDraft(
  requestBody: CreateVehicleFinancingTemplateRequestBody,
  identity: TemplateIdentity
) {
  return {
    id: identity.id,
    archived: identity.archived,
    automatic: identity.automatic,
    automaticPosition: identity.automaticPosition,
    name: requestBody.name,
    validFrom: requestBody.validFrom,
    validTo: requestBody.validTo,
    expirationAction: requestBody.expirationAction,
    replacementTemplateId: requestBody.replacementTemplateId,
    type: requestBody.type,
    interestRateType: requestBody.interestRateType,
    financialInstitutionCodeId: requestBody.financialInstitutionCodeId,
    processingFee: requestBody.oneTimeCosts.processingFee,
    vehicleTransferIncluded: requestBody.oneTimeCosts.vehicleTransfer.included,
    vehicleTransferAmount: requestBody.oneTimeCosts.vehicleTransfer.amount,
    vehicleRegistrationIncluded: requestBody.oneTimeCosts.vehicleRegistration.included,
    vehicleRegistrationAmount: requestBody.oneTimeCosts.vehicleRegistration.amount,
    vehicleDeliveryIncluded: requestBody.oneTimeCosts.vehicleDelivery.included,
    vehicleDeliveryAmount: requestBody.oneTimeCosts.vehicleDelivery.amount,
    tradeInPossible: requestBody.tradeInPossible,
    creditProtectionAutoEnable: requestBody.creditProtectionAutoEnable,
    scope: requestBody.scope,
    downPaymentStep: requestBody.downPaymentStep,
    balloonPaymentStep: requestBody.balloonPaymentStep,
    defaultTerm: requestBody.defaultTerm,
    defaultDownPayment: requestBody.defaultDownPayment,
    defaultBalloonPayment: requestBody.defaultBalloonPayment,
    rateMatrix: requestBody.rateMatrix,
  };
}
